
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widgets/alert",
      function () {
        return require("private-next-pages/widgets/alert.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widgets/alert"])
      });
    }
  